import Project from '../../common/Utils/project';
import { useToast } from '../../providers/ToastProvider/ToastContext';
import { useApi } from './apiService';

export const useTenantGroupService = () => {
  const api = useApi();
  const { addToast } = useToast();

  /**
   * Create or update a Tenant Group
   */
  const createOrUpdateTenantGroup = async (token: string, tenantId: string, createGroupData: any, values: any) => {
    try {
      const isUpdate = !!createGroupData.TenantGroupId;
      const endpoint = `${Project.api}tenantservice/TenantGroup/${tenantId}/${isUpdate ? 'update' : 'create'}-tenant-group`;

      // Map days if needed
      // const daysMap: Record<string, string> = {
      //   Sun: 'Sunday',
      //   Mon: 'Monday',
      //   Tue: 'Tuesday',
      //   Wed: 'Wednesday',
      //   Thu: 'Thursday',
      //   Fri: 'Friday',
      //   Sat: 'Saturday',
      // };

      const payload = {
        ...createGroupData,
        groupMaintenanceSchedule: [
          {
            ...createGroupData.groupMaintenanceSchedule?.[0],
            // timeWindowStart: values.startTime,
            // timeWindowEnd: values.endTime,
            // daysOfWeek: values.selectedDays.map((day: string) => daysMap[day]),
            interval: 1,
          },
        ],
        groupAgentRebootDelayConfiguration: {
          delayRebootByUnit: values.delayRebootByUnit,
          delayRebootValue: values.delayRebootValue,
        },
      };

      delete payload.timezoneValue;
      delete payload.searchValues;
      delete payload.selectedDevices;
      delete payload.selectedDeviceIds;

      const response = await api.post(endpoint, payload);
      if (response?.status === 200) {
        addToast(`Tenant group ${isUpdate ? 'updated' : 'created'} successfully.`, 'success', 5000);
      }
      return response.data;
    } catch (error: any) {
      console.error('Error creating/updating tenant group:', error?.response?.data || error);
      throw error;
    }
  };

  /**
   * Enable or disable a Tenant Group
   */
  const toggleTenantGroupStatus = async (
    token: string,
    tenantId: string,
    groupId: string,
    isGroupActive: boolean,
    onSuccess?: () => void,
  ) => {
    try {
      const endpoint = isGroupActive
        ? `${Project.api}tenantservice/TenantGroup/${tenantId}/disable-tenant-group/${groupId}`
        : `${Project.api}tenantservice/TenantGroup/${tenantId}/enable-tenant-group/${groupId}`;

      const response = await api.put(endpoint, '');

      if (response?.status === 200) {
        addToast(isGroupActive ? 'Group disabled successfully' : 'Group enabled successfully', 'success', 4000);

        // optional callback for parent refresh
        if (onSuccess) {
          setTimeout(() => onSuccess(), 3500);
        }
      }

      return response.data;
    } catch (err) {
      // Error toast handled globally in apiService
      console.error('Error toggling group status:', err);
      throw err;
    }
  };
  const addGPA = async (policyAutomationData: any) => {
    try {
      const token = policyAutomationData?.token; // Or pass token separately if needed
      const isUpdate = !!policyAutomationData?.groupPolicyAutomationId;

      const url = `${Project.api}grouppolicyservice/GroupPolicyAutomation/${isUpdate ? 'update' : 'create'}plan`;

      const method = isUpdate ? 'PUT' : 'POST';

      const response = await api({
        method,
        url,
        data: policyAutomationData,
      });
      if (response?.status === 200) {
        addToast(`Group Policy Automation ${isUpdate ? 'updated' : 'created'} successfully.`, 'success', 4000);
      }

      return response.data;
    } catch (error: any) {
      console.error('Error creating/updating Group Policy Automation:', error?.response?.data || error);
      throw error;
    }
  };

  return {
    createOrUpdateTenantGroup,
    toggleTenantGroupStatus,
    addGPA,
  };
};
